module.exports = __webpack_public_path__ + "img/rank-2-bg.a4923407.png";